<template>
  <div class="max_box" :style="'min-height:' + height + 'px;'">
    <div class="box_form">
      <div>
        <p style="color: #676767;margin-bottom: 5px;">订单号 :</p>
        <el-input style="width: 220px" v-model="form.orderNum" placeholder="请输入贵司订单号/科坦订单号"
                  size="mini" clearable></el-input>
      </div>
      <div>
        <p style="color: #676767;margin-bottom: 5px;">申请时间 :</p>
        <el-date-picker v-model="form.applyDates" type="daterange" range-separator="-"
                        start-placeholder="开始时间" end-placeholder="结束时间"
                        value-format="yyyy-MM-dd" size="mini"
                        style="position: relative;top: 2px;width: 230px !important;">
        </el-date-picker>
      </div>
      <div>
        <p style="color: #676767;margin-bottom: 5px;">开票类型 :</p>
        <el-select v-model="form.invoiceType" placeholder="请选择" style="width: 110px;" size="mini" clearable>
          <el-option label="普票" :value="1"></el-option>
          <el-option label="专票" :value="2"></el-option>
        </el-select>
      </div>
      <div>
        <p style="color: #676767;margin-bottom: 5px;">开票状态 :</p>
        <el-select v-model="form.applyStatus" placeholder="请选择" style="width: 110px;" size="mini" clearable>
          <el-option label="申请中" :value="0"></el-option>
          <el-option label="审批通过" :value="1"></el-option>
          <el-option label="审批不通过" :value="2"></el-option>
          <el-option label="已开票" :value="3"></el-option>
        </el-select>
      </div>
      <div>
        <p style="color: #676767;margin-bottom: 15px;"></p>
        <b2b-button style="width: 60px;height: 28px;line-height: 28px;" @click="onSearch(true)">搜 索</b2b-button>
      </div>
    </div>

    <el-table :data="logs" style="width: 100%; margin-top: 20px; font-size: 12px">
      <el-table-column label="发票单号" prop="invoiceNumber" width="185"></el-table-column>
      <el-table-column label="发票抬头" prop="invoiceTitle" width="255"></el-table-column>
      <el-table-column label="开票类型" width="80">
        <template slot-scope="scope">
          {{ scope.row.invoiceType === 1 ? '普票' : '专票' }}
        </template>
      </el-table-column>
      <el-table-column label="开票金额" prop="payAmount" width="80">
        <template slot-scope="scope">
          {{ scope.row.totalAmount ? `￥${scope.row.totalAmount / 100}` : '' }}
        </template>
      </el-table-column>
      <el-table-column label="状态" prop="payAmount" width="100">
        <template slot-scope="scope">
          <div style="display: flex;align-items: center;column-gap: 5px">
            <div class="dot" :style="`background-color: ${statusColor[scope.row.applyStatus]}`"></div>
            <span :style="`color: ${statusColor[scope.row.applyStatus]}`">{{ statusMap[scope.row.applyStatus] }}</span>
          </div>
        </template>
      </el-table-column>
      <el-table-column label="申请时间" prop="createDate" width="145"></el-table-column>
      <el-table-column label="操作">
        <template slot-scope="scope">
          <span style="color:#1e50f0;cursor: pointer;margin-right: 10px" @click="toInvoiceDetail(scope.row)">详情</span>
          <span style="color:#1e50f0;cursor: pointer;margin-right: 10px" v-if="scope.row.fileUrls"
                @click="downLoadInvoice(scope.row)">下载发票</span>
        </template>
      </el-table-column>
    </el-table>

    <div class="pagination">
      <el-pagination :current-page="form.pageCurrent" :page-size="form.pageSize"
                     layout="total, prev, pager, next, jumper" :total="form.total" :hide-on-single-page="true"
                     @current-change="pageChange" style="margin: auto;">
      </el-pagination>
    </div>
  </div>
</template>

<script>
export default {
  name: 'invoiceList',
  data () {
    return {
      form: {
        pageSize: 10,
        pageCurrent: 1,
        total: 0
      },
      partnerInfo: {},
      headers: {},
      logs: [],
      height: 0,
      statusMap: {
        0: '申请中',
        1: '审批通过',
        2: '审批不通过',
        3: '已开票'
      },
      statusColor: {
        0: '#909399',
        1: '#67c23a',
        2: '#f16767',
        3: '#67c23a'
      }
    }
  },
  created () {
    this.partnerInfo = JSON.parse(this.$common.isLogin())
    this.headers = {accessToken: this.partnerInfo.token}
    if (!this.partnerInfo) {
      this.$message.warning('请登录后再查看')
      this.$router.push('/login')
    }
    this.height = this.$common.getScreenInfo().height - 90 - 40
    this.onSearch(true)
  },
  methods: {
    pageChange (e) {
      this.form.pageCurrent = e
      this.onSearch()
    },
    async onSearch (type) {
      if (type) {
        this.form.pageCurrent = 1
      }
      const {data: result} = await this.$http.post('/b2b/getInvoiceApplyLogs', this.form, {headers: this.headers})
      if (result.code !== 200) return this.$message.error(result.message)
      this.logs = result.data.data
      this.form.total = result.data.total
    },
    toInvoiceDetail (row) {
      let url = `/invoiceDetail?id=${row.applyId}`
      window.open(url, '_blank')
    },
    async downLoadInvoice (row) {
      if (!row.fileUrls) return
      try {
        let urls = JSON.parse(row.fileUrls)
        for (const item of urls) {
          const {data: result} = await this.$http.get(`/b2b/downloadInvoiceFile?url=${item}`, {responseType: 'blob'}, {headers: this.headers})
          if (result) {
            const link = document.createElement('a')
            let fileName = item.substring(item.lastIndexOf('/') + 1)
            const fileExtension = fileName.split('.').pop()
            let blob = new Blob([result], {type: `application/${fileExtension};charset=utf-8`})
            link.style.display = 'none'
            link.href = URL.createObjectURL(blob)
            link.setAttribute('download', fileName)
            document.body.appendChild(link)
            link.click()
            document.body.removeChild(link)
          }
        }
        this.$message.success('下载成功')
      } catch (e) {

      }
    }
  }
}
</script>

<style scoped lang="less">
.max_box {
  background-color: #fff;
  padding: 20px;
}

.box_form {
  padding: 20px;
  border: 1px solid #e7e7e7;
  background-color: #f7f7f7;
  margin-bottom: 15px;
  display: flex;
  flex-wrap: wrap;
  column-gap: 15px;
  row-gap: 15px;
  align-items: center;

  .time_box {
    display: grid;
    grid-template-columns: repeat(3, max-content);
    align-items: center;
    grid-column-gap: 10px;
  }

  & /deep/ .el-input .el-select {
    min-width: auto !important;
    width: auto !important;
  }
}

.pagination {
  margin: 35px;
  position: relative;

  /deep/ .el-pagination {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
}

.dot {
  width: 5px;
  height: 5px;
  border-radius: 100px;
}
</style>



// WEBPACK FOOTER //
// src/pages/newPages/order/components/invoiceList.vue